import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import Button from 'orionsoft-parts/lib/components/Button'
import Download from './Download'
import Resend from './Resend'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withRouter
@withMessage
export default class Buttons extends React.Component {

  static propTypes = {
    router: PropTypes.object,
    url: PropTypes.bool,
    params: PropTypes.object,
    document: PropTypes.object,
    me: PropTypes.func,
    organization: PropTypes.object,
    initFeaFlow: PropTypes.func,
    showMessage: PropTypes.func
  }
  state = {
    value: '',
    copied: false
  }
  renderDocState() {
    return (
      <div className="col-xs-12 col-sm-8 start-md">
        <div className={styles.state}>
          <MdCheckCircle size={30} style={{color: '#3cb371'}} />
          El documento ha sido firmado por todos sus participantes
        </div>
      </div>
    )
  }

  renderPreviewButton(isAdmin = false) {
    const docRoute = isAdmin ? `/admin/${this.props.params._id}/${this.props.params.documentId}/preview` : `/documents/${this.props.document._id}/preview`
      console.log("El documento:", this.props.document);
      if(this.props.document.hasPreview)
      return (
        <div className="col-xs-12 col-sm-6 start-md">
          <Button
            onClick={() => {
              this.props.router.push(docRoute)
            }}
          >
          Ver documento
          </Button>
        </div>
      )
  }
  renderResend() {
    return (
      <div className="col-xs-12 col-sm-6 end-md">
        <Resend document={this.props.document} />
      </div>
    )
  }
  renderDownload() {
    return (
      <div className="col-xs-12 col-sm-12 end-md">
        <div className={styles.feaState}>
          <Download document={this.props.document} />
        </div>
      </div>
    )
  }

  renderButton(isAdmin = false) {
    return (
      <div className="content">
        <div className="row">
          {this.renderDocState()}
          {/* {this.renderCopyURL()} */}
        </div>
        <div className="row">
          {this.renderPreviewButton(isAdmin)}
          {this.renderResend()}
        </div>
        <div className="row">
          {this.renderDownload()}
        </div>
      </div>
    )
  }

  render() {
    return this.renderButton(!!this.props.url)
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Ready/Title/Buttons/index.js